<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <!-- Default toolbar -->
    @if (!isSearchFocused) {
      @if (contractorRole) {
        <app-primary-button (click)="create()" class="!w-[150px]"> Create</app-primary-button>
      }
      <!-- Download Submittal Report Button -->
      @if (submittalReport) {
        <div class="download-button-container">
          @if (downloading) {
            <mat-spinner
              color="primary"
              diameter="24"
              mode="indeterminate"
              strokeWidth="3"
              >
            </mat-spinner>
          }
          @if (!downloading) {
            <button
              (click)="downloadSubmittalReport()"
              class="download-button"
              mat-icon-button
              [matTooltip]="statusIdsToFilter?.length ? 'Download filtered Submittals' : 'Download all Submittals'"
              >
              <mat-icon>download</mat-icon>
            </button>
          }
        </div>
      }
      <div class="submittals-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
        <app-project-details-page-date-filter [defaultDateValue]="defaultDateValue" />
        <app-status-filter [statusOptions]="statusList" />
        <div>
          @if (selectedSortColumn) {
            <mat-form-field class="sort-dropdown">
              <mat-select
                (selectionChange)="onSortColumnChange($event)"
                [(value)]="selectedSortColumn"
                disableOptionCentering
                panelClass="submittals-sort-panel"
                >
                <mat-select-trigger>
                  {{ selectedSortColumn ? 'Sort by: ' + selectedSortColumn : 'Sort: ' }}
                </mat-select-trigger>
                @for (column of sortByColumns; track column) {
                  <mat-option [value]="column">
                    {{ column | titlecase }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix> close</mat-icon>
            </mat-form-field>
          }
          @if (!selectedSortColumn) {
            <div (click)="openSortDropdown($event)" class="sort-dropdown nosort">
              <div class="label text-type-8">Sort:</div>
              <mat-icon>sync_alt</mat-icon>
              <!-- Hidden select used only to open the same dropdown without changing layout -->
              <mat-form-field class="sr-sort-hidden">
                <mat-select
                  #sortSelect
                  (selectionChange)="onSortColumnChange($event)"
                  [(value)]="selectedSortColumn"
                  disableOptionCentering
                  panelClass="submittals-sort-panel"
                  >
                  @for (column of sortByColumns; track column) {
                    <mat-option [value]="column">
                      {{ column | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
          <form [formGroup]="form" class="flex-1 min-w-0">
            <div class="search w-full">
              <mat-icon (click)="search()" svgIcon="search"></mat-icon>
              <input
                (focus)="onSearchFocus()"
                class="search-input"
                formControlName="searchText"
                matInput
                placeholder="Search"
                />
              @if (form.controls.searchText.value) {
                <mat-icon (click)="close()" svgIcon="close"></mat-icon>
              }
            </div>
          </form>
        </div>
      </div>
    } @else {
      <form [formGroup]="form" class="flex-1 min-w-0">
        <div class="search w-full">
          <mat-icon (click)="search()" svgIcon="search"></mat-icon>
          <input
            #searchInput
            (focus)="onSearchFocus()"
            class="search-input"
            formControlName="searchText"
            matInput
            placeholder="Search"
            />
          <mat-icon (click)="close()" svgIcon="close"></mat-icon>
        </div>
      </form>
    }

    <!-- Full-width search bar -->
  </div>

  <div class="list-section">
    <div class="submittals-list-table flex flex-col gap-[40px]">
      <!-- ✅ Table -->
      @if (dataSource?.length) {
        <div class="bit-items-table">
          <table [dataSource]="dataSource" class="mat-elevation-z8 table" mat-table>
            <!-- Submittal No -->
            <ng-container matColumnDef="submittalNo">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Submittal no'" mat-header-cell>
                <span class="th-text">Submittal #</span>
                @if (selectedSortColumn === 'Submittal no') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type11">{{ row?.submittal_no }}</div>
              </td>
            </ng-container>
            <!-- Spec Ref No -->
            <ng-container matColumnDef="specRefNo">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Spec ref no'" mat-header-cell>
                <span class="th-text">Spec ref #</span>
                @if (selectedSortColumn === 'Spec ref no') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type11">{{ row?.spec_reference_no }}</div>
              </td>
            </ng-container>
            <!-- Title -->
            <ng-container matColumnDef="title">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Title'" mat-header-cell>
                <span class="th-text">Title</span>
                @if (selectedSortColumn === 'Title') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-8">{{ row?.title }}</div>
                <div class="description text-type-14">{{ row?.description }}</div>
              </td>
            </ng-container>
            <!-- Due Date -->
            <ng-container matColumnDef="dueDate">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Due date'" mat-header-cell>
                <span class="th-text">Due date</span>
                @if (selectedSortColumn === 'Due date') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ row?.due_date | date : 'MMM d, y' }}</div>
              </td>
            </ng-container>
            <!-- Sent Date -->
            <ng-container matColumnDef="sentDate">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Sent date'" mat-header-cell>
                <span class="th-text">Sent date</span>
                @if (selectedSortColumn === 'Sent date') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="text-type-11">{{ formatInProjectTimezone(row?.sent_date, 'MMM D, YYYY') }}</div>
                <div class="text-type-14">{{ formatInProjectTimezone(row?.sent_date, 'h:mm A') }}</div>
              </td>
            </ng-container>
            <!-- Status -->
            <ng-container matColumnDef="status">
              <th
                *matHeaderCellDef
                [class.ellipsis-header]="selectedSortColumn === 'Status'"
                class="text-type-6 !leading-[24px]"
                mat-header-cell
                >
                <span class="th-text">Status</span>
                @if (selectedSortColumn === 'Status') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="status-chip-container">
                  <div
                  [ngClass]="
                    row?.status && statusMap[row?.status]
                      ? [statusMap[row.status].bgColor, statusMap[row.status].textColor]
                      : []
                  "
                    class="status-chip px-[14px] rounded-full"
                    >
                    {{ statusMap[row?.status]?.label }}
                  </div>
                </div>
              </td>
            </ng-container>
            <!-- Latest Activity -->
            <ng-container matColumnDef="latestActivity">
              <th *matHeaderCellDef [class.ellipsis-header]="selectedSortColumn === 'Latest activity'" mat-header-cell>
                <span class="th-text">Latest activity</span>
                @if (selectedSortColumn === 'Latest activity') {
                  <span>
                    <mat-icon (click)="toggleSortDirection()" class="sort-column">
                      {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                  </span>
                }
              </th>
              <td *matCellDef="let row" mat-cell>
                <div class="action text-type-11">{{ row?.latest_lineage?.state?.comment }}</div>
                <div class="actor text-type-14">
                  {{ row?.latest_lineage?.actor?.first_name }} {{ row?.latest_lineage?.actor?.last_name }}
                </div>
                <div class="created-at text-type-14">
                  {{ formatInProjectTimezone(row?.latest_lineage?.created_at, 'MMM D, YYYY, h:mm A') }}
                </div>
              </td>
            </ng-container>
            <!-- Header & Row Definitions -->
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr
              data-testid="submittal-row"
              (click)="rowClicked(row)"
              *matRowDef="let row; columns: displayedColumns"
              [class.highlighted-row]="row === selectedRow"
              mat-row
            ></tr>
          </table>
        </div>
      }

      <!-- ✅ No Data -->
      @if (!dataSource?.length) {
        <div class="no-data text-type-8 mt-[80px]">No data available.</div>
      }

      <!-- ✅ Paginator -->
      <app-paginator
        (pageChanged)="onPageChanged($event)"
        [itemsPerPage]="pagination?.pageSize"
        [maxVisiblePages]="5"
        [totalItems]="totalRecords"
        class="paginator"
        />
    </div>
  </div>
</div>
